(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.StoreAvailability = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  function normalizeBranchCode(value) {
    return String(value || '').trim().toUpperCase();
  }

  function toQuantity(value) {
    const quantity = Number(value);
    return Number.isFinite(quantity) ? quantity : 0;
  }

  function buildStoreAvailability(branchMap, branchAvailability, options) {
    const settings = options || {};
    const complete = settings.complete === true;
    const excludedCodes = new Set(
      (settings.excludedBranchCodes || []).map(normalizeBranchCode)
    );
    const stockByBranch = new Map();

    (Array.isArray(branchAvailability) ? branchAvailability : []).forEach((stock) => {
      const code = normalizeBranchCode(stock && stock.branchCode);
      if (code) stockByBranch.set(code, stock);
    });

    return Object.entries(branchMap || {})
      .filter(([code]) => !excludedCodes.has(normalizeBranchCode(code)))
      .map(([code, store]) => {
      const normalizedCode = normalizeBranchCode(code);
      const baseStore = {
        ...store,
        branchCode: code,
      };

      if (!complete) {
        return {
          ...baseStore,
          quantity: null,
          status: 'unknown',
          inventoryFreshness: settings.inventoryFreshness || 'unavailable',
        };
      }

      const stock = stockByBranch.get(normalizedCode);
      const quantity = stock ? toQuantity(stock.quantity) : 0;

      return {
        ...baseStore,
        branchName: stock && stock.branchName ? stock.branchName : store.name,
        quantity,
        unit: stock && stock.unit ? stock.unit : 'pieces',
        status: quantity > 0 ? 'in_stock' : 'out_of_stock',
        inventoryFreshness: settings.inventoryFreshness || 'fresh',
      };
    });
  }

  return { normalizeBranchCode, buildStoreAvailability };
});
